import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["as", "className"],
  _excluded2 = ["className", "children", "data-testid"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BreadcrumbsItem = function BreadcrumbsItem(props) {
  var _props$as = props.as,
    As = _props$as === void 0 ? 'a' : _props$as,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var finalClasses = classnames('C-Breadcrumbs__Item', className);
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses
  }, otherProps));
};
BreadcrumbsItem.displayName = 'Breadcrumbs.Item';
var Breadcrumbs = function Breadcrumbs(_ref) {
  var className = _ref.className,
    children = _ref.children,
    dataTestId = _ref['data-testid'],
    otherProps = _objectWithoutProperties(_ref, _excluded2);
  alertUserOfDeprecatedProps('Breadcrumbs', otherProps);
  var finalClasses = classnames('C-Breadcrumbs', className);

  // makes sure children always come in as an array
  var childrenToRender = React__default.Children.toArray(children);
  return /*#__PURE__*/React__default.createElement("nav", {
    "aria-label": "breadcrumbs"
  }, /*#__PURE__*/React__default.createElement("ul", {
    "data-testid": dataTestId,
    className: finalClasses
  }, childrenToRender.map(function (child, childIndex) {
    // return the children with dividers
    // last child has no divider, is a p tag and gets any click events/hrefs ripped off of it
    var lastChild = false;
    var modifiedProps;
    if (childIndex === childrenToRender.length - 1) {
      lastChild = true;
      modifiedProps = _objectSpread(_objectSpread({}, child.props), {}, {
        as: 'p',
        href: null,
        onClick: null
      });
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: "frag_".concat(childIndex)
    }, lastChild ? /*#__PURE__*/React__default.createElement("li", {
      className: "--last",
      key: "child_".concat(childIndex)
    }, /*#__PURE__*/React__default.createElement(BreadcrumbsItem, modifiedProps)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("li", {
      key: "child_".concat(childIndex)
    }, child), /*#__PURE__*/React__default.createElement("li", {
      key: "caret_".concat(childIndex),
      className: "C-Breadcrumbs__Divider",
      "aria-hidden": "true"
    }, "/")));
  })));
};
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.Item = BreadcrumbsItem;

export { Breadcrumbs as default };
